export default {
    topics: [
        {
            title: ' buildNumber ',
            href: 'p-Application-buildNumber.html',
            attributes: { 'data-id': 'p-Application-buildNumber' },
            menu: { hasChildren: false },
            tocID: 'p-Application-buildNumber-d66e5789',
            topics: [],
        },
        {
            title: ' getConnection ',
            href: 'm-Application-getConnection.html',
            attributes: { 'data-id': 'm-Application-getConnection' },
            menu: { hasChildren: false },
            tocID: 'm-Application-getConnection-d66e5797',
            topics: [],
        },
        {
            title: ' getDBMSType ',
            href: 'm-Application-getDBMSType.html',
            attributes: { 'data-id': 'm-Application-getDBMSType' },
            menu: { hasChildren: false },
            tocID: 'm-Application-getDBMSType-d66e5805',
            topics: [],
        },
        {
            title: ' getNewIds ',
            href: 'm-Application-getNewIds.html',
            attributes: { 'data-id': 'm-Application-getNewIds' },
            menu: { hasChildren: false },
            tocID: 'm-Application-getNewIds-d66e5813',
            topics: [],
        },
        {
            title: ' getSchema ',
            href: 'm-Application-getSchema.html',
            attributes: { 'data-id': 'm-Application-getSchema' },
            menu: { hasChildren: false },
            tocID: 'm-Application-getSchema-d66e5821',
            topics: [],
        },
        {
            title: ' getTimezoneJson ',
            href: 'm-Application-getTimezoneJson.html',
            attributes: { 'data-id': 'm-Application-getTimezoneJson' },
            menu: { hasChildren: false },
            tocID: 'm-Application-getTimezoneJson-d66e5829',
            topics: [],
        },
        {
            title: ' hasPackage ',
            href: 'm-Application-hasPackage.html',
            attributes: { 'data-id': 'm-Application-hasPackage' },
            menu: { hasChildren: false },
            tocID: 'm-Application-hasPackage-d66e5837',
            topics: [],
        },
        {
            title: ' instanceName ',
            href: 'p-Application-instanceName.html',
            attributes: { 'data-id': 'p-Application-instanceName' },
            menu: { hasChildren: false },
            tocID: 'p-Application-instanceName-d66e5845',
            topics: [],
        },
        {
            title: ' instanceUploadDir ',
            href: 'p-Application-instanceUploadDir.html',
            attributes: { 'data-id': 'p-Application-instanceUploadDir' },
            menu: { hasChildren: false },
            tocID: 'p-Application-instanceUploadDir-d66e5853',
            topics: [],
        },
        {
            title: ' instanceVarDir ',
            href: 'p-Application-instanceVarDir.html',
            attributes: { 'data-id': 'p-Application-instanceVarDir' },
            menu: { hasChildren: false },
            tocID: 'p-Application-instanceVarDir-d66e5861',
            topics: [],
        },
        {
            title: ' locale ',
            href: 'p-Application-locale.html',
            attributes: { 'data-id': 'p-Application-locale' },
            menu: { hasChildren: false },
            tocID: 'p-Application-locale-d66e5870',
            topics: [],
        },
        {
            title: ' onLog ',
            href: 'm-Application-onLog.html',
            attributes: { 'data-id': 'm-Application-onLog' },
            menu: { hasChildren: false },
            tocID: 'm-Application-onLog-d66e5878',
            topics: [],
        },
        {
            title: ' onTrace ',
            href: 'm-Application-onTrace.html',
            attributes: { 'data-id': 'm-Application-onTrace' },
            menu: { hasChildren: false },
            tocID: 'm-Application-onTrace-d66e5886',
            topics: [],
        },
        {
            title: ' operator ',
            href: 'p-Application-operator.html',
            attributes: { 'data-id': 'p-Application-operator' },
            menu: { hasChildren: false },
            tocID: 'p-Application-operator-d66e5894',
            topics: [],
        },
    ],
};

